import React from 'react';
import { CockpitButton } from 'components/views/atoms/CockpitButton';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

export type AccelSettingButtonProps = {
    size?: SizeProp;
    onClick?: () => void;
}

export const AccelSettingButton = (props: AccelSettingButtonProps) => {
    return (
        <CockpitButton icon={faSlidersH} {...props} />
    );
};
